<template>
    <div id="MainContent">
        <h1>User Profiles</h1>
        
        <!-- Loading Message -->
        <p v-if="!dataLoaded">Loading...</p>
        
        <!-- Data is Loaded -->
        <div v-else>
                <!-- Specific User -->    
                <UserDetail v-if="$route.params.id"></UserDetail>

                <!-- All Users -->
                <button v-if="!$route.params.id && $store.User.admin" @click="ShowCreate = !ShowCreate">Add New</button>
                <table v-if="!$route.params.id">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>First Name</th>
                        <th>Surname</th>
                        <th>Email</th>
                        <th>Member Since</th>
                        <th>Last Login</th>
                        <th>Account Type</th>
                    </tr>
                    <tr v-if="$store.User.admin" v-show="ShowCreate">
                        <th><button @click="SaveNewUser">Save</button></th>
                        <th><input type="text" v-model="newUser.fname"></th>
                        <th><input type="text" v-model="newUser.lname"></th>
                        <th><input type="text" v-model="newUser.email"></th>
                        <th>Auto Generated</th>
                        <th>Auto Generated</th>
                        <th><select v-model="newUser.admin"><option value="0">Salesperson</option><option vlaue="1">Admin</option></select></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in users" :key="user.id">
                        <td><router-link :to="'/users/'+user.id">{{user.id}}</router-link></td>
                        <td><router-link :to="'/users/'+user.id">{{user.fname}}</router-link></td>
                        <td><router-link :to="'/users/'+user.id">{{user.lname}}</router-link></td>
                        <td>{{user.email}}</td>
                        <td>{{user.created}}</td>
                        <td>{{user.last_login}}</td>
                        <td>{{user.admin ? "Admin" : "Salesperson"}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    // Import Helpers
    import {CallApi} from '../Utilities.js'
    import UserDetail from '../components/UserDetail'

    // Module Code
    export default {
        components: {UserDetail}, 
        data: function () {
            return {
                newUser: {
                    fname:'',
                    lname:'',
                    email:'',
                    password:'',
                    admin: 0,
                },
                ShowCreate: false,
                dataLoaded: false,
                users: [],
            }
        },
        methods: {
            fetchData: async function() {
                this.users  =  (await CallApi('GET', '/users')).users
                this.users.map((e) => {
                    e.created = new Date(e.created).toLocaleString("en-AU");
                    e.last_login = new Date(e.last_login).toLocaleString("en-AU");
                })
                this.dataLoaded = true
            },
            SaveNewUser: async function() {
                const apiResponse = await CallApi('POST', '/users', this.newUser)
                if (apiResponse.user){
                    this.users.push(apiResponse.user)
                    this.newUser = {}
                }                
            }
        },
        mounted() {
            this.fetchData();
        }
    }
</script>
